import { render, staticRenderFns } from "./Deangelo.vue?vue&type=template&id=9311a1a2&scoped=true&"
import script from "./Deangelo.vue?vue&type=script&lang=js&"
export * from "./Deangelo.vue?vue&type=script&lang=js&"
import style0 from "./Deangelo.vue?vue&type=style&index=0&id=9311a1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9311a1a2",
  null
  
)

export default component.exports